var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.getClosedStyle("navigation") }, [
    _c("div", { class: _vm.getClosedStyle("header") }, [
      _vm.open
        ? _c("div", { class: _vm.$style.headerText }, [
            _c("div", { class: _vm.$style.headerTitle }, [
              _vm._v("Hotel Directory"),
            ]),
            _c("div", { class: _vm.$style.headerSubTitle }, [
              _vm._v("Admin Dashboard"),
            ]),
          ])
        : _vm._e(),
      _c("div", { class: _vm.$style.headerButtonContainer }, [
        _c(
          "button",
          {
            staticClass: "button dark icon-only",
            class: _vm.getClosedStyle("headerButton"),
            on: { click: _vm.toggleState },
          },
          [
            _c(
              "i",
              {
                staticClass: "material-icons",
                class: _vm.open ? _vm.$style.iconBack : _vm.$style.iconFront,
              },
              [_vm._v("play_for_work")]
            ),
          ]
        ),
      ]),
    ]),
    _c(
      "ul",
      { class: _vm.$style.menu },
      [
        _c(
          "navigation-item",
          {
            attrs: {
              id: _vm.modules.previewAndEdit,
              active: _vm.isActive(_vm.modules.previewAndEdit),
              open: _vm.open,
              text: "Preview And Edit",
              icon: "remove_red_eye",
            },
          },
          [
            _vm.directory
              ? _c("view-list", {
                  class: _vm.$style.menu,
                  attrs: { views: _vm.views, "active-view": _vm.activeView },
                  on: {
                    open: _vm.openView,
                    createView: _vm.createView,
                    updateView: _vm.updateView,
                    deleteView: _vm.deleteView,
                  },
                })
              : _vm._e(),
          ],
          1
        ),
        _c("navigation-item", {
          attrs: {
            id: _vm.modules.manageHotels,
            active: _vm.isActive(_vm.modules.manageHotels),
            open: _vm.open,
            text: "Manage Hotels",
            icon: "business",
          },
        }),
        _c("navigation-item", {
          attrs: {
            id: _vm.modules.manageNotes,
            active: _vm.isActive(_vm.modules.manageNotes),
            open: _vm.open,
            text: "Manage Notes",
            icon: "description",
          },
        }),
        _c("navigation-item", {
          attrs: {
            id: _vm.modules.manageLocations,
            active: _vm.isActive(_vm.modules.manageLocations),
            open: _vm.open,
            text: "Manage Locations",
            icon: "store",
          },
        }),
        _c("navigation-item", {
          attrs: {
            id: _vm.modules.manageUsers,
            active: _vm.isActive(_vm.modules.manageUsers),
            open: _vm.open,
            text: "Manage Users",
            icon: "supervised_user_circle",
          },
        }),
        _c("navigation-item", {
          attrs: {
            id: _vm.modules.editTravelPolicy,
            active: _vm.isActive(_vm.modules.editTravelPolicy),
            open: _vm.open,
            text: "Edit Travel Policy",
            icon: "description",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }